import Dexie from "dexie";

const db = new Dexie("Kyupid");
db.version(1).stores({
  areas: "++id,objectid,user_count,revenue,male_count,female_count,info",
  users: "++id,user_id,objectid,is_pro",
});
export default db;
